// src/services/adminJobs.js
import { collection, query, orderBy, getDocs } from "firebase/firestore";
import { db } from "../firebase";

// Admin view: fetch ALL jobs, newest first.
// Status filtering is done client-side to avoid composite indexes.
export async function fetchAllJobs() {
  const q = query(collection(db, "jobs"), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}